import React from "react";
import { Alert, Box, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import { normalizeIdArray } from "../utils/companyUtils";

export default function SectionHotelgruppen({
                                                form,
                                                setForm,
                                                hotelGroups,
                                                hotelGroupsLoading,
                                                hotelGroupsError,
                                            }) {
    const activeGroups = React.useMemo(
        () => (hotelGroups || []).filter((group) => group.is_active === undefined || !!group.is_active),
        [hotelGroups]
    );

    const selectedIds = normalizeIdArray(form.hotel_group_ids);

    const toggleHotelGroup = (id) => {
        setForm((f) => {
            const ids = new Set(normalizeIdArray(f.hotel_group_ids));
            if (ids.has(id)) ids.delete(id);
            else ids.add(id);
            return { ...f, hotel_group_ids: Array.from(ids).sort((a, b) => a - b) };
        });
    };

    if (hotelGroupsError) {
        return <Alert severity="error">{hotelGroupsError}</Alert>;
    }

    if (hotelGroupsLoading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={20} />
            </Box>
        );
    }

    if (!activeGroups.length) {
        return <Alert severity="info">Keine Hotelgruppen vorhanden. Lege zuerst Hotelgruppen an.</Alert>;
    }

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                {selectedIds.length} von {activeGroups.length} ausgewählt
            </Typography>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(3, minmax(0, 1fr))",
                        lg: "repeat(4, minmax(0, 1fr))",
                    },
                    gap: 0.25,
                    maxHeight: 260,
                    overflowY: "auto",
                    pr: 1,
                    py: 0.5,
                }}
            >
                {activeGroups.map((group) => {
                    const id = Number(group.id);
                    const checked = selectedIds.includes(id);
                    const label = group.label_de || group.name;
                    return (
                        <FormControlLabel
                            key={group.id}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checked}
                                    onChange={() => toggleHotelGroup(id)}
                                    sx={{ py: 0.5 }}
                                />
                            }
                            label={label}
                            sx={{
                                m: 0,
                                minWidth: 0,
                                borderRadius: 1,
                                px: 0.75,
                                py: 0.25,
                                bgcolor: checked ? "rgba(240, 172, 77, 0.10)" : "transparent",
                                "&:hover": { bgcolor: "action.hover" },
                                "& .MuiFormControlLabel-label": {
                                    fontSize: "0.875rem",
                                    lineHeight: 1.25,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
